/** @deprecated @type {Zeta.Dictionary} */
const defaults = {};
export default defaults;
